export const PLANS_CALL = "PLANS_CALL";

export function callPlans() {
  return { type: PLANS_CALL };
}
